import api from "src/apis/api"

// Returns { organization, user_overrides, effective, can_edit_organization }.
export async function fetchNotificationSettings() {
  const { data } = await api.get("/api/v1/notification_settings")
  return data
}

// scope: "organization" (admin, org-wide defaults) or "user" (self overrides).
export async function updateNotificationSettings(settings, scope = "user") {
  const { data } = await api.patch(
    `/api/v1/notification_settings?scope=${scope}`,
    { settings }
  )
  return data
}
